import * as JsPDF from 'jspdf'
import image from '../../../resources/images/receipt/base64Coloured'
import moment from 'moment/moment'
import dummyQR from './dummyQR'
import { free3of9Base64, ocrbBase64 } from './fonts/free/base64'

const PAGE_SIZE = 6

const prescriptionIcon = 'data:image/png;base64,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'

/**
 * Draws a dotted line on a jsPDF doc between two points.
 * Note that the segment length is adjusted a little so
 * that we end the line with a drawn segment and don't
 * overflow.
 */
function dottedLine (doc, xFrom, yFrom, xTo, yTo, segmentLength) {
  // Calculate line length (c)
  let a = Math.abs(xTo - xFrom)
  let b = Math.abs(yTo - yFrom)
  let c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2))

  // Make sure we have an odd number of line segments (drawn or blank)
  // to fit it nicely
  let fractions = c / segmentLength
  let adjustedSegmentLength = (Math.floor(fractions) % 2 === 0) ? (c / Math.ceil(fractions)) : (c / Math.floor(fractions))

  // Calculate x, y deltas per segment
  let deltaX = adjustedSegmentLength * (a / c)
  let deltaY = adjustedSegmentLength * (b / c)

  let curX = xFrom
  let curY = yFrom
  while (curX <= xTo && curY <= yTo) {
    doc.line(curX, curY, curX + deltaX, curY + deltaY)
    curX += 2 * deltaX
    curY += 2 * deltaY
  }
}

class MaterializedReceiptGenerator {
  constructor (prescriptionNumber, date, patientName, patientNumber, phoneNumber, dispensaryAccessCode, optionCode, prescriptionSite, prescriber, contactNumber, medicines, way) {
    this.doc = new JsPDF('l', 'pt', [595, 842])
    this._medicines = medicines
    this._way = way
    this._patientNumber = patientNumber
    this._phoneNumber = phoneNumber
    this._prescriptionNumber = prescriptionNumber
    this._date = date.toString()
    this._patientName = patientName
    this._dispensaryAccessCode = dispensaryAccessCode.toString()
    this._optionCode = optionCode.toString()
    this._prescriptionSite = prescriptionSite
    this._prescriber = prescriber
    this._contactNumber = contactNumber.toString()
    this.createDocument()
  }

  get prescriptionNumber () {
    return this._prescriptionNumber
  }

  get date () {
    return this._date
  }

  get patientName () {
    return this._patientName
  }

  get dispensaryAccessCode () {
    return this._dispensaryAccessCode
  }

  get optionCode () {
    return this._optionCode
  }

  get prescriptionSite () {
    return this._prescriptionSite
  }

  get prescriber () {
    return this._prescriber
  }

  get contactNumber () {
    return this._contactNumber
  }

  get medicines () {
    return this._medicines
  }

  get way () {
    return this._way
  }

  get patientNumber () {
    return this._patientNumber
  }

  get phoneNumber () {
    return this._phoneNumber
  }

  pageNumbering () {
    const {doc} = this
    doc.setFontSize('8')
    doc.text(`Pág. ${doc.currentPage} de ${doc.totalPages}`, 575, 822, {align: 'right'})
  }

  drawFooter (page = 1) {
    const {doc} = this
    doc.setFontSize('5')
    doc.text('Processado por computador - SCRIBO, v2.3.0 - Kenetto, EPE.', 15, 665, {angle: 90})
    doc.setFontSize('7')
    doc.setFontStyle('bold')
    doc.text('*Os preços são válidos à data da prescrição. Para verificar se houve alterações nos preços dos medicamentos:', 20, 633)
    doc.setFontStyle('normal')
    doc.text(' • Consulte «Pesquisa Medicamento» em www.infarmed.pt ou «Poupe na Receita» no seu telemóvel\n' +
      ' • Contacte a Linha do Medicamento 800 222 444 (Dias úteis: 09.00-13.00 e 14.00-17.00)\n' +
      ' • Fale com o seu médico ou farmacêutico.', 20, 641)
    dottedLine(doc, 10, 672, 585, 672, 5)
    doc.setFillColor(203, 203, 203)
    doc.rect(20, 677, 555, 15, 'F')
    doc.setFontSize('9')
    doc.text('Códigos para utilização pela farmácia em caso de falência do sistema informático.', 25, 688)

    // draw QR Codes
    const currentPageMedicines = [...this.medicines].slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

    currentPageMedicines.forEach((medicine, index) => {
      const lineNumber = this.medicines.findIndex(element => element === medicine)
      // console.log(indexInArray)
      if (medicine.qrCode) {
        this.drawQRCode(medicine.qrCode, index, lineNumber)
      }
    })
  }

  // TODO remove test QR Code
  drawQRCode (data, index, lineNumber) {
    const {doc} = this
    const shiftValue = 90
    const initialPositions = {
      indexOutline: [20 + index * shiftValue, 697, 15, 14],
      indexTextPosition: [28 + index * shiftValue, 707],
      qrCodeOutline: [40 + index * shiftValue, 702, 65, 65],
      qrCodeTextPosition: [72 + index * shiftValue, 735],
      qrCodePosition: [40 + index * shiftValue, 702, 65, 65]
    }
    doc.rect(...initialPositions.indexOutline)
    doc.setFontSize('10')
    doc.text((lineNumber + 1).toString(), ...initialPositions.indexTextPosition, {align: 'center'})
    // doc.rect(...initialPositions.qrCodeOutline)
    const image = data === '' ? dummyQR : data
    doc.addImage(image, 'PNG', ...initialPositions.qrCodePosition)
  }

  drawMedicine (rowData, index) {
    const {doc} = this
    const {fullDesignation, dosage, quantity, expiryDate, costs} = rowData
    const lineHeight = 60
    const indexOnPage = index < PAGE_SIZE ? index : (index % PAGE_SIZE)
    const initialPositions = {
      outline: [20, 195 + lineHeight * indexOnPage, 555, 60],
      indexOutline: [20, 195 + lineHeight * indexOnPage, 15, 15],
      indexTextPosition: [28, 206 + lineHeight * indexOnPage],
      name: [40, 206 + lineHeight * indexOnPage],
      dosage: [40, 226 + lineHeight * indexOnPage],
      quantity: [413, 228 + lineHeight * indexOnPage],
      expiryDate: [457, 228 + lineHeight * indexOnPage],
      costs: [488, 215 + lineHeight * indexOnPage]
    }
    // outline
    doc.rect(...initialPositions.outline)

    // index box
    doc.rect(...initialPositions.indexOutline)
    doc.setFontSize('10')
    doc.text((index + 1).toString(), ...initialPositions.indexTextPosition, {align: 'center'})

    // medicine name
    // the second parameter inside splitTextToSize is the width in pixels
    const fullDesignationLines = doc.setFontSize('8').splitTextToSize(fullDesignation, 360)

    // doc.text(0.5, verticalOffset + size / 72, lines)
    doc.text(fullDesignationLines, ...initialPositions.name)

    const verticalOffset = 4 * (fullDesignationLines.length - 1)
    // dosage
    doc.setFontStyle('italic')
    const dosageLines = doc.setFontStyle('italic').splitTextToSize(dosage, 360)
    doc.text(dosageLines, initialPositions.dosage[0], initialPositions.dosage[1] + verticalOffset)

    // quantity
    doc.setFontStyle('normal')
    doc.text(quantity.toString(), ...initialPositions.quantity)

    // expiry date
    doc.text(expiryDate.toString(), ...initialPositions.expiryDate, {align: 'center'})

    // costs
    doc.setFontSize('7')
    doc.text(`Esta prescrição custa-lhe,\nno máximo € ${costs}, a não\nser que opte por um\nmedicamento mais caro.`, ...initialPositions.costs)
  }

  drawTableHeader () {
    const {doc} = this
    doc.setLineWidth(1)
    doc.rect(20, 175, 555, 20)

    doc.setFontSize('6')
    doc.text('DCI / Nome, dosagem, forma farmacêutica, embalagem, posologia', 25, 187)

    doc.text('Quant.', 407, 187)

    doc.text('Validade da\nprescrição', 457, 183, {align: 'center'})

    doc.text('Encargos*', 525, 187, {align: 'center'})
  }

  drawHeader () {
    const {doc} = this
    // add portuguese republic logo
    doc.addImage(image, 'JPEG', 25, 20, 122, 25)

    doc.setFontSize('9.5')
    doc.text(220, 20, 'Receita Médica Nº')
    // add receipt barcode
    doc.addFileToVFS('free3of9.ttf', free3of9Base64)
    doc.addFont('free3of9.ttf', 'free3of9', 'normal')
    doc.setFont('free3of9')
    doc.setFontSize('24')
    doc.text(150, 46, `*${this.prescriptionNumber}*`)
    const barcodeWidth = doc.getTextWidth(`*${this.prescriptionNumber}*`)
    doc.addFileToVFS('OCRB.otf', ocrbBase64)
    doc.addFont('OCRB.otf', 'ocrb', 'normal')
    doc.setFont('ocrb')
    doc.setFontSize('10')
    doc.text(150 + (barcodeWidth / 2), 56, `*${this.prescriptionNumber}*`, {align: 'center'})

    doc.setFont('helvetica')
    doc.setFontSize('10.5')
    doc.text(365, 40, `${this.way}ª Via`, {align: 'center'})

    // writing the date
    //
    // doc.setFont('helvetica')
    // doc.setFontSize('9')
    // doc.text(`Data: ${this.date}`, 570, 75, {align: 'right'})
    //
    // // writing document title
    //
    // doc.setFontSize('14')
    // const textLength = doc.getTextWidth('Guia de Tratamento para o Utente')
    // doc.setFillColor(203, 203, 203)
    // doc.rect(20, 85, textLength + 10, 32, 'F')
    // doc.text('Guia de Tratamento para o Utente', 23, 100)
    // doc.setFontSize('10')
    // doc.text('Não deixe este documento na Farmácia', 125, 113, {align: 'center'})
    //
    // // writing patient Identification
    //
    // doc.setFontSize('8')
    // doc.text(`Utente: ${this.patientName.toUpperCase()}`, 20, 135)
    //
    // // writing receipt identification
    //
    // doc.text(`Código de Acesso e Dispensa: *${this.dispensaryAccessCode}*`, 20, 160)
    //
    // doc.text(`Código de Opção: *${this.optionCode}*`, 215, 160)
    //
    // doc.text('Local de Prescrição:', 330, 150)
    // doc.text('Prescritor:', 330, 160)
    // doc.text('Telefone:', 330, 170)
    //
    // const prescriptionLocationLength = doc.getTextWidth('Local de Prescrição:')
    //
    // doc.text(this.prescriptionSite, 330 + prescriptionLocationLength + 5, 150)
    // doc.text(this.prescriber, 330 + prescriptionLocationLength + 5, 160)
    // doc.text(this.contactNumber, 330 + prescriptionLocationLength + 5, 170)
  }

  drawLeftContent () {
    const { doc } = this

    doc.setFontSize('6')
    doc.setFontStyle('italic')
    doc.text('Processado por computador - SCRIBO, v1.0.0 - Kenetto, Lda.', 15, 480, {angle: 90})
    doc.setFontStyle('normal')

    doc.setLineWidth(1)
    doc.rect(20, 75, 280, 72)

    doc.setFontSize('6')
    doc.text('Utente: ', 23, 84)

    doc.text('Valentin Mirchev', 44, 84)

    doc.text('Telefone:', 23, 103)

    doc.text(this.phoneNumber, 50, 103)

    doc.text('R.C:', 120, 99)

    doc.text('Entidade Responsável:', 23, 121)

    doc.text('Nº do Beneficiário:', 23, 139)

    doc.setFont('free3of9')
    doc.setFontSize('20')

    doc.setFont('free3of9')
    doc.setFontSize('19')
    doc.text(210, 94, `*${this.patientNumber}*`)
    const barcodeWidth = doc.getTextWidth(`*${this.patientNumber}*`)
    doc.addFileToVFS('OCRB.otf', ocrbBase64)
    doc.addFont('OCRB.otf', 'ocrb', 'normal')
    doc.setFont('ocrb')
    doc.setFontSize('6')
    doc.text(210 + (barcodeWidth / 2), 100, `*${this.patientNumber}*`, {align: 'center'})

    doc.rect(20, 147, 105, 40)

    doc.setFont('helvetica')
    doc.setFontSize('6')
    doc.text(`(Nº da cédula \nprofissional, em código de\nbarras e caracteres ou\n vinheta de prescritor)`, 70, 160, {align: 'center'})

    doc.rect(125, 147, 175, 40)

    doc.text(`(Nome profissional)`, 195, 154, {align: 'center'})

    doc.setFontSize('5')

    doc.text(`Especialidade:`, 130, 165)

    doc.text(`Telefone:`, 130, 180)

    doc.rect(300, 147, 80, 40)

    doc.setFontSize('6')

    doc.text(`(Local de Prescrição)`, 340, 154, {align: 'center'})

    doc.text(`(Representação em\ncódigo de barras e\ncaracteres)`, 340, 165, {align: 'center'})

    doc.rect(20, 187, 360, 10)

    doc.addImage(prescriptionIcon, 'png', 22, 188.5, 6, 7)

    doc.setFontSize('5')

    doc.text('DCI/Nome, dosagem, forma farmacêutica, embalagem, posologia', 32, 194)

    doc.text('Nº Extenso', 255, 194)

    doc.text('Identificação Ótica', 320, 194)

    doc.rect(20, 197, 360, 300)

    doc.rect(20, 197, 10, 10)

    doc.text('1', 23.5, 204)

    doc.rect(20, 272, 10, 10)

    doc.text('2', 23.5, 279)

    doc.rect(20, 347, 10, 10)

    doc.text('3', 23.5, 354)

    doc.rect(20, 422, 10, 10)

    doc.text('4', 23.5, 429)

    doc.rect(20, 497, 190, 60)

    doc.text('Validade: 6 meses', 22, 517)

    doc.text('Data: aaa-mm-dd', 22, 542)

    doc.text('(assinatura do prescritor)', 92, 550)

    doc.rect(210, 497, 170, 60)

    doc.text('Pretendo excercer o direito de opção', 295, 505, {align: 'center'})

    doc.rect(215, 515, 7, 7)

    doc.text('Sim', 225, 520)

    doc.rect(215, 535, 7, 7)

    doc.text('Não', 225, 540)

    doc.text('(assinatura do Utente)', 298, 550, {align: 'center'})
  }

  drawVerticalSeparator () {
    const { doc } = this
    dottedLine(doc, 395, 10, 395, 585, 5)
  }

  drawRightSide () {
    const { doc } = this
    doc.rect(410, 30, 400, 80)

    doc.setFontSize('10')
    doc.text('Guia de Tratamento para o utente', 620, 25, {align: 'center'})

    doc.setFontSize('9.5')
    doc.text(420, 50, 'Receita Médica Nº')
    // add receipt barcode
    doc.setFont('free3of9')
    doc.setFontSize('24')
    doc.text(570, 56, `*${this.prescriptionNumber}*`)
    const barcodeWidth = doc.getTextWidth(`*${this.prescriptionNumber}*`)
    doc.addFileToVFS('OCRB.otf', ocrbBase64)
    doc.addFont('OCRB.otf', 'ocrb', 'normal')
    doc.setFont('ocrb')
    doc.setFontSize('10')
    doc.text(570 + (barcodeWidth / 2), 66, `*${this.prescriptionNumber}*`, {align: 'center'})

    doc.setFont('helvetica')
    doc.setFontSize('8')
    doc.text('Local de Prescrição:', 415, 75)
    doc.text('Prescritor:', 415, 90)
    doc.text('Telefone:', 685, 90)
    doc.text('Utente:', 415, 105)

    doc.rect(410, 110, 400, 50)
    doc.text('Código de Acesso:', 415, 125)
    doc.text('Código Direito opção:', 655, 125)

    doc.setFontSize('7')
    doc.text('(Informação a utilizar para dispensa de medicamentos na farmácia)', 415, 155)

    doc.rect(410, 160, 400, 15)

    doc.setFontSize('6')

    doc.text('DCI/Nome, dosagem, forma farmacêutica, embalagem, posologia', 415, 170)

    doc.text('Nº', 785, 170)

    doc.rect(410, 175, 400, 260)

    doc.rect(410, 175, 10, 10)

    doc.text('1', 413.5, 182)

    doc.rect(410, 240, 10, 10)

    doc.text('2', 413.5, 247)

    doc.rect(410, 315, 10, 10)

    doc.text('3', 413.5, 322)

    doc.rect(410, 370, 10, 10)

    doc.text('4', 413.5, 377)

    doc.rect(410, 435, 400, 70)

    doc.text('Encargo para o utente de acordo com os mediacamentos comercializados que cumprem a prescrição médica:', 415, 445)

    doc.rect(410, 450, 10, 10)
    doc.text('1', 413.5, 457)

    doc.rect(410, 463, 10, 10)
    doc.text('2', 413.5, 471)

    doc.rect(410, 476, 10, 10)
    doc.text('3', 413.5, 483)

    doc.rect(410, 489, 10, 10)
    doc.text('4', 413.5, 496)

    doc.rect(410, 505, 400, 40)

    doc.setFontType('bold')
    doc.text('Para obter mais informações sobre o preço dos medicamentos:', 415, 515)

    doc.setFontType('normal')

    doc.setFillColor(0, 0, 0)
    doc.ellipse(420, 525, 1.5, 1.5, 'F')
    doc.text('Consulte «Pesquisa Medicamento», no sítio do INFARMED (www.infarmed.pt)', 425, 527)

    doc.ellipse(420, 532, 1.5, 1.5, 'F')
    doc.text('Consulte a Linha do Medicamento 800 222 444 (Dias úteis: 09.00-13.00 e 14.00-17.00)', 425, 534)

    doc.ellipse(420, 539, 1.5, 1.5, 'F')
    doc.text('Consulte «Pesquisa Medicamento», no sítio do INFARMED (www.infarmed.pt);', 425, 541)

    doc.rect(410, 545, 400, 15)

    doc.setFontSize('7')

    doc.text(`Data: ${moment(this.date).format('YYYY-MM-DD')}`, 415, 555)

    doc.setFontSize('6')
    doc.setFontStyle('italic')
    doc.text('Processado por computador - SCRIBO, v1.0.0 - Kenetto, Lda.', 412, 570)

  }

  addPage () {
    const {doc} = this
    doc.addPage()
    this.drawHeader()

    this.drawLeftContent()

    this.drawVerticalSeparator()

    this.drawRightSide()

    doc.currentPage += 1
  }

  createDocument () {
    console.log('Generating Document')
    const {doc, medicines} = this
    doc.currentPage = 1
    doc.totalPages = Math.floor((medicines.length / PAGE_SIZE)) + 1
    this.pageNumbering()
    this.drawHeader()
    this.drawLeftContent()
    this.drawVerticalSeparator()
    this.drawRightSide()

    // medicines draw

    medicines.forEach((medicine, index) => {
      if (index > 0 && index % 6 === 0) {
        this.addPage()
      }
      this.drawMedicine(medicine, index)
    })
  }

  getBlobUri () {
    return this.doc.output('bloburi')
  }

  getArrayBuffer () {
    return this.doc.output('arraybuffer')
  }

  getBlob () {
    return this.doc.output('blob')
  }

  getBlobUrl () {
    return this.doc.output('bloburl')
  }

  getDataUriString () {
    return this.doc.output('datauristring')
  }

  getDataUrlString () {
    return this.doc.output('dataurlstring')
  }

  getDataUri () {
    return this.doc.output('datauri')
  }

  getDataUrl () {
    return this.doc.output('dataurl')
  }

  saveDocument (name = `Receita-${moment().format('DD-MM-YYYY')}.pdf`) {
    return this.doc.save(name)
  }
}

export default MaterializedReceiptGenerator
